import React, { useEffect, useState, useRef } from "react";
import loginLogo from "../../assets/images/login-signup/loginLogo.png";
import loginImg from "../../assets/images/login-signup/login.png";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import { object, string } from "yup";
import { axiosInstance } from "../../axiosInstance";

export function Otp() {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [resendEnabled, setResendEnabled] = useState(false);
  const inputRefs = useRef([]);
  const navigate = useNavigate();

  async function verifyOtp() {
    const enteredOtp = otp.join("");
    const email = localStorage.getItem("email");
    const payload = {
      otp: enteredOtp,
      email: email,
      userType: "USER",
    };

    if (enteredOtp.length < 4) {
      toast.error("Please enter a valid 4-digit OTP");
      return;
    }

    try {
      const { data } = await axiosInstance.post("/verifyOtp", payload);

      if (data.status === 200) {
        toast.success("OTP Verified!");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        toast.error("Invalid OTP!");
      }
    } catch (error) {
      console.error("OTP verification failed", error);
      toast.error("Something went wrong!");
    }
  }

  // Start countdown timer
  const startCountdown = () => {
    setMinutes(10);
    setSeconds(0);
    setResendEnabled(false);
  };

  useEffect(() => {
    startCountdown(); // start timer on component mount
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds((prev) => prev - 1);
      } else if (minutes > 0) {
        setMinutes((prev) => prev - 1);
        setSeconds(59);
      } else {
        clearInterval(interval);
        setResendEnabled(true); // enable resend when timer ends
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [minutes, seconds]);

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < 3) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  // const sendOTP = () => {
  //   setOtp(["", "", "", ""]);
  //   startCountdown();
  //   // Optional: Send OTP API call
  // };

  const resendOTP = () => {
    setOtp(["", "", "", ""]);
    startCountdown();
    // Optional: Resend OTP API call
  };

  return (
    <>
      <ToastContainer />
      <div className="login-container container">
        <div className="login-subcontainer">
          <div className="login-left">
            <div className="login-logo">
              <img src={loginLogo} />
            </div>

            <div className="loginForm-container">
              <div className="otp-title">
                We have sent you <b>One Time Password</b> to your email
              </div>
              <div className="otp-subtitle">Please Enter OTP</div>

              <div>
                <div className="otpField">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      ref={(el) => (inputRefs.current[index] = el)}
                    />
                  ))}
                </div>

                {/* <div className="btnLogin">
                    <button onClick={sendOTP} style={{ marginTop: "10px" }}>
                      Generate OTP
                    </button>
                  </div> */}

                <div className="countdown-text" style={{ marginTop: "10px" }}>
                  {seconds > 0 || minutes > 0 ? (
                    <p>
                      Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </p>
                  ) : (
                    <p>Didn't receive code?</p>
                  )}

                  <button
                    disabled={!resendEnabled}
                    className="btnResend"
                    style={{
                      color: resendEnabled ? "#090657" : "gray",
                      cursor: resendEnabled ? "pointer" : "not-allowed",
                    }}
                    onClick={resendOTP}
                  >
                    Resend OTP
                  </button>
                </div>
              </div>

              <div className="btnLogin">
                <button type="button" onClick={verifyOtp}>
                  Verify OTP
                </button>
              </div>

              <div className="btnCreate">
                <Link to="/forgot">
                  <button>Back</button>
                </Link>
              </div>
            </div>
          </div>

          <div className="login-right">
            <div>
              <img src={loginImg} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
